const messageConfig = require("@/models/messageConfig.js")

const grossRateValidator = (rule, value, callback, source) => {
  const bValidate = (value || "") !== ""

  if (!bValidate && value !== 0) {
    source.grossRate = 0;
    return false
  }

  return true;
}
const quantityValidator = (rule, value, callback, source) => {

  const bValidate = parseFloat(value || "0") !== 0
  if (!bValidate) {
    source.quantity = 0;
  }

  return bValidate;
}

const Number_Validation = (rule, value) => {
  value = value || 0
  return parseFloat(value) !== "NaN" && !isNaN(value) && !isNaN(parseFloat(value));
};
const Null_Validation = (rule, value) => {
  return value != null;
};



module.exports = {
  mediaSelectRules: {
    selectedMediaInfo: {
      type: 'array',
      required: true,
      message: messageConfig.getMessage("validmediarequire"),
    },
    mediaCampaignPeriod: {
      type: "array",
      required: true,
      message: messageConfig.getMessage("validformrequire")
    },
    mediaType: {
      message: messageConfig.getMessage('diffplatform')
    }
  },
  contractMediaRules: {
    grossRate: [{
      required: true,
      message: messageConfig.getMessage("errornumber"),
      validator: grossRateValidator
    },
    {
      message: messageConfig.getMessage("errornumber"),
      validator: Number_Validation
    }],
    quantity: [{
      required: true,
      message: messageConfig.getMessage("errornumber"),
      validator: quantityValidator
    }, {
      message: messageConfig.getMessage("errornumber"),
      validator: Number_Validation
    }]
    ,
    dates: [{
      required: true,
      message: messageConfig.getMessage("validformrequire"),
      validator: Null_Validation
    }]
  }
}
